module.exports = __webpack_public_path__ + "img/thumbnail_PronghornAntelope_f_albino.6091c6ea.png";